import React, {useEffect, useState} from "react";
import {ApexOptions} from "apexcharts";
import {SerieGraph} from "../../../services/interface/catalogs/serie-graph";
import {useTranslation} from "react-i18next";
import {GraphicMachineInterface} from "../../../services/interface/query/graphic-machining-interface";
import {useFindGraphicMachining} from "../../../services/apis/apiWorkInformation";
import {Person} from "../../../services/interface/query/person";
import CustomGraphicChart from "../../components/custom-graphic-chart";
import {CustomOptionsConfig} from "../../components/custom-graphic-chart/CustomOptionsConfig";

interface Props {
    person?: Person;
    title?: string;
    msj?: string;
    className?: string;
}
export default function GraphicMachiningComponent({title, msj, className, person}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findGraphicMachining,
        data: successGraphicMachining,
        isPending: loadingGraphicMachining,
        error: errorGraphicMachining
    } = useFindGraphicMachining();

    const [response, setResponse] = useState<GraphicMachineInterface | undefined>()
    const [option, setOption] = useState<any>({idSelect: 12, descriptionData: t('12-months')})
    const [optionsSelect, setOptionsSelect] = useState<any[]>([])
    const [series, setSeries] = React.useState<SerieGraph[] | undefined>();
    const [options, setOptions] = React.useState<ApexOptions | undefined>();

    useEffect(() => {
        if (person && person.identification && option) {
            setOptions(CustomOptionsConfig)
            findGraphicMachining({
                identifier: person.identification,
                months: option.idSelect,
                msj: msj
            })
        }
    }, [person, option]);

    useEffect(() => {
        if (successGraphicMachining) {
            setResponse(successGraphicMachining);
        }
    }, [successGraphicMachining]);

    useEffect(() => {
        if (response) {
            const y: number[] = []
            const y2: number[] = []
            const x: string[] = []
            response?.data?.forEach(item => {
                if (item.axisY) y.push(item.axisY)
            })
            response?.dataForecast?.forEach(item => {
                if (item.axisX && item.axisY) {
                    y2.push(item.axisY)
                    x.push(item.axisX)
                }
            })
            setSeries([
                {data: y2, name: 'Proyección de ingresos'},
                {data: y, name: 'Ingresos'},
            ]);
            let config = CustomOptionsConfig;
            if (config.xaxis) {
                config.xaxis.categories = x;
            }
            setOptions(config);

            if (optionsSelect.length === 0 && response?.catalogAxisX && response.catalogAxisX.length > 0) {
                setOptionsSelect(response.catalogAxisX.map(opt => ({
                    idSelect: opt.codeCatalog ? parseInt(opt.codeCatalog) : 12,
                    descriptionData: opt.descriptionCatalog
                })))
            }
        }
    }, [response]);

    return (
        <>
            <CustomGraphicChart
                className={className}
                service={'/income/graphic-machining'}
                loading={loadingGraphicMachining}
                error={errorGraphicMachining}
                {...{
                    title,
                    options,
                    option,
                    setOption,
                    optionsSelect,
                    series,
                    response
                }}
            />
        </>
    )
}
